import { styled } from 'styled-components';
import { textSmallNormal, ellipsisExperimental } from '../../Typography';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-50);
  color: var(--text-standard-secondary);

  span {
    ${ellipsisExperimental};
    ${textSmallNormal};
  }

  svg {
    position: relative;
    top: 1px;
  }

  svg path {
    color: var(--text-standard-secondary);
  }
`;
